import moment from "moment";

import * as actionTypes from "../constants";
import { GridCodeType } from "../models";

import type { ElixhauserAnalyzeResult, ElixhauserAnalyzeState } from "../models/elixhauser";

const createEmptyElixhauserAnalyzeState = (isLoading?: boolean): ElixhauserAnalyzeState => ({
  loading: isLoading ?? false,
});

const handleEccAnalyzeBegin = (state: ElixhauserAnalyzeState): ElixhauserAnalyzeState => ({
  ...state,
  loadedAt: undefined,
  loading: true,
  result: undefined,
});

const handleEccAnalyzeReset = (state: ElixhauserAnalyzeState): ElixhauserAnalyzeState => ({
  ...state,
  loadedAt: undefined,
  loading: false,
  result: undefined,
});

const handleEccAnalyzeCompleted = (
  state: ElixhauserAnalyzeState,
  payload: ElixhauserAnalyzeResult,
): ElixhauserAnalyzeState => ({
  ...state,
  loadedAt: moment.now().toString(),
  loading: false,
  result: payload,
});

export const elixhauserAnalyzeReducer = (
  state = createEmptyElixhauserAnalyzeState(),
  action,
): ElixhauserAnalyzeState => {
  switch (action.type) {
    case actionTypes.OPEN_ENCOUNTER_BY_ID_COMPLETED:
    case actionTypes.CREATE_NEW_ENCOUNTER:
    case actionTypes.CODE_GRID_MOVE_TO_PDX:
      return createEmptyElixhauserAnalyzeState();
    case actionTypes.CLEAR_GRID:
      return action.payload === GridCodeType.DIAGNOSES ?
          createEmptyElixhauserAnalyzeState()
        : state;
    case actionTypes.PDX_ANALYZE_TOGGLE:
      return action.payload ? createEmptyElixhauserAnalyzeState() : state;
    case actionTypes.ECC_ANALYZE_TOGGLE:
      return action.payload ? state : createEmptyElixhauserAnalyzeState();
    case actionTypes.ECC_ANALYZE_BEGIN:
      return handleEccAnalyzeBegin(state);
    case actionTypes.ECC_ANALYZE_ERROR:
      return handleEccAnalyzeReset(state);
    case actionTypes.ECC_ANALYZE_COMPLETED:
      return handleEccAnalyzeCompleted(state, action.payload);
    default:
      return state;
  }
};
